// Copyright ID Business Solutions Ltd. 2024
import messages_en from './en.json';

const messages = {
  en: messages_en,
};

export default messages;
